import ToolTip from "../../Block/ToolTip";

type Props = {
  lang?: string;
  className?: string;
  hasTermsInConsent?: boolean;
  signUpText?: string;
};

export const newsletterConsentText = ({
  lang,
  className,
  hasTermsInConsent,
  signUpText,
}: Props) => {
  let consentText;
  if (lang === "zh") {
    consentText = (
      <>
        是的，我想要收到新报业媒体有限公司{" "}
        <ToolTip text="新报业媒体有限公司相关公司、附属机构以及代理和授权服务提供商。">
          ⓘ
        </ToolTip>{" "}
        的相关促销信息。
      </>
    );
  } else {
    consentText = (
      <>
        Yes, I would also like to receive SPH Media Group&apos;s{" "}
        <ToolTip text="SPH Media Limited, its related corporations and affiliates as well as their agents and authorised service providers.">
          ⓘ
        </ToolTip>{" "}
        marketing and promotions.
      </>
    );
  }

  if (hasTermsInConsent) {
    return (
      <>
        {consentText}
        {newsletterTermsText({
          lang,
          className,
          signUpText,
        })}
      </>
    );
  }

  return consentText;
};

export const newsletterTermsText = ({
  lang,
  className,
  hasTermsInConsent,
  signUpText,
}: Props) => {
  if (hasTermsInConsent) return null;

  if (lang === "zh") {
    return (
      <>
        透过提交上述资料并点击“{signUpText || "SIGN UP"}
        ”，我理解并接受新报业媒体因时而更改的{" "}
        <a
          href="https://www.sph.com.sg/tnc/website"
          className={className}
          target="_blank"
        >
          条款和条件
        </a>{" "}
        以及{" "}
        <a
          href="https://www.sph.com.sg/tnc/privacy"
          className={className}
          target="_blank"
        >
          隐私条款
        </a>
        。
      </>
    );
  } else {
    return (
      <>
        By submitting my information above and clicking &apos;
        {signUpText || "SIGN UP"}&apos;, I confirm I understand and accept{" "}
        <a
          href="https://www.sph.com.sg/tnc/website"
          className={className}
          target="_blank"
        >
          SPH Media Terms & Conditions
        </a>{" "}
        and{" "}
        <a
          href="https://www.sph.com.sg/tnc/privacy"
          className={className}
          target="_blank"
        >
          Privacy Policy
        </a>{" "}
        as amended from time to time.
      </>
    );
  }
};
